import { FormlyFieldConfig } from 'ng-formly';
export const dashboardFields: Array<FormlyFieldConfig> = [
    {
        key: 'group',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Dashboard Group'
        }
    },
    {
        key: 'developmentstatus',
        type: 'select-component',
        defaultValue: 'Yet to Start',
        templateOptions: {
            options: [{
                label: 'Yet to Start',
                value: 'Yet to Start'
            }, {
                label: 'Work in Progress',
                value: 'Work in Progress'
            }, {
                label: 'Completed',
                value: 'Completed'
            }, {
                label: 'Approved',
                value: 'Approved'
            }],
            label: 'Development Status',
            required: true,
            placeholder: ''
        }
    },
    {
        key: 'developmentpriority',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Development Priority'
        }
    },
    {
        key: 'developmentnotes',
        type: 'textarea-field',
        templateOptions: {
            placeholder: '',
            required: false,
            label: 'Development Team Notes'
        }
    },
    {
        key: 'name',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Name'
        }
    },
    {
        key: 'description',
        type: 'input-field',
        templateOptions: {
            type: 'text',
            placeholder: '',
            required: true,
            label: 'Description'
        }
    },

    {
        type: 'repeatedsection',
        key: 'widgets',
        fieldArray: {
            className: 'row',
            templateOptions: {
                btnText: 'Add Widget',
            },
            fieldGroup: [
                {
                    className: 'col-md-1',
                    type: 'input-field',
                    key: 'index',
                    templateOptions: {
                        type: 'text',
                        label: 'Order',
                        required: true,
                    },
                },
                {
                    className: 'col-md-3',
                    type: 'input-field',
                    key: 'title',
                    templateOptions: {
                        type: 'text',
                        label: 'Widget Title',
                        required: false,
                    },
                },
                {
                    className: 'col-md-2',
                    type: 'input-field',
                    key: 'cssclass',
                    templateOptions: {
                        type: 'text',
                        label: 'CSS Class',
                        required: false,
                        description: 'Widget Width'
                    },
                },
                {
                    key: 'dataelement',
                    type: 'select-component',
                    className: 'col-md-4',
                    templateOptions: {
                        type: 'dataelement',
                        label: 'DataElement',
                        required: true,
                        description: 'Enter ObjectId'
                    }
                },
                {
                    key: 'type',
                    type: 'select-component',
                    className: 'col-md-2',
                    templateOptions: {
                        options: [{
                            label: 'Table',
                            value: 'table'
                        },
                        {
                            label: 'Metric',
                            value: 'metric'
                        },
                        {
                            label: 'Pie Chart',
                            value: 'piechart'
                        },
                        {
                            label: 'Line Chart',
                            value: 'linechart'
                        },
                        {
                            label: 'Bar Chart',
                            value: 'barchart'
                        },
                        {
                            label: 'Area Chart',
                            value: 'area'
                        },
                        {
                            label: 'Events Chart',
                            value: "eventschart"
                        },
                        {
                            label: 'Scatter Chart',
                            value: 'scatter'
                        }, {
                            label: 'Radar Chart',
                            value: 'radar'
                        }, {
                            label: 'Funnel Chart',
                            value: 'funnel'
                        }, {
                            label: 'Graph Chart',
                            value: 'graph'
                        }, {
                            label: 'Heatmap',
                            value: 'heatmap'
                        }, {
                            label: 'Gauge',
                            value: "gaugechart"
                        }, {
                            label: 'Boxplot',
                            value: 'boxplot'
                        }, {
                            label: 'Punch Card',
                            value: 'punchcard'
                        }, {
                            label: 'Candle Stick',
                            value: 'candlestick'
                        }, {
                            label: 'Parallel',
                            value: 'parallel'
                        }],
                        label: 'Widget Type',
                        required: true,
                        placeholder: 'Select Type'
                    }
                },
                {
                    key: 'basefield',
                    type: 'input-field',
                    className: 'col-md-3',
                    hideExpression: '(!model.type || !model.type.endsWith("chart"))',
                    templateOptions: {
                        type: 'text',
                        label: 'Base Field',
                        required: false
                    },
                    expressionProperties: {
                        'templateOptions.required': '(model.type && model.type.endsWith("chart")) ? true : false'
                    }
                },
                {
                    key: 'comparefield',
                    type: 'input-field',
                    className: 'col-md-3',
                    hideExpression: '(!model.type || !model.type.endsWith("chart") || model.type === "gaugechart")',
                    templateOptions: {
                        type: 'text',
                        label: 'Compare Field',
                        required: false
                    },
                    expressionProperties: {
                        'templateOptions.required': '(model.type && model.type.endsWith("chart") && model.type !== "gaugechart") ? true : false'
                    }
                },
                {
                    key: 'range',
                    type: 'select-component',
                    className: 'col-md-2',
                    hideExpression: '(!model.type || model.type !== "eventschart")',
                    templateOptions: {
                        label: 'Range',
                        required: false,
                        options: [
                            { label: 'Last 3 Years', value: 'last3years' },
                            { label: 'Last Years', value: 'last1year' },
                            { label: 'Year', value: '1year' },
                            { label: 'Last 6 Months', value: 'last6months' },
                            { label: '6 Months', value: '6months' },
                            { label: 'Last 3 Months', value: 'last3months' },
                            { label: '3 Months', value: '3months' },
                            { label: 'One Month', value: '1month' },
                            { label: 'Last 1 Week', value: 'last1week' },
                            { label: 'One Week', value: '1week' }
                        ]
                    },
                    expressionProperties: {
                        'templateOptions.required': '(model.type && model.type === "eventschart") ? true : false'
                    }
                },
                {
                    key: 'rangefield',
                    type: 'input-field',
                    className: 'col-md-3',
                    hideExpression: '(!model.type || model.type !== "eventschart")',
                    templateOptions: {
                        type: 'text',
                        label: 'Range Field Name',
                        required: false
                    },
                    expressionProperties: {
                        'templateOptions.required': '(model.type && model.type === "eventschart") ? true : false'
                    }
                }
            ]
        }
    }
];


// WEBPACK FOOTER //
// ./src/app/shared/formfields/dashboard.ts